import React, { FC } from "react";
import { PartitionOutlined, PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import styles from "./data-import-header.css";
import { ImportState } from "./data-import";

const { ["container"]: containerClassName } = styles as any;

export type DataImportHeaderLabels = {
  addNewButtonLabel?: string;
  importButtonLabel?: string;
  cancelButtonLabel?: string;
  retryButtonLabel?: string;
  finishButtonLabel?: string;
};

export type DataImportHeaderProps = {
  onClickAddNew?: () => void;
  onClickImport?: () => void;
  onClickCancel?: () => void;
  onClickRetry?: () => void;
  onClickFinish?: () => void;
  onImportData?: () => void;
  onViewImportedLibrary?: () => void;
  importState: ImportState;
  onShowSchema: () => void;
  labels: DataImportHeaderLabels;
  schemaLoading?: boolean;
  islibaryScope: boolean;
};

export const DataImportHeader: FC<DataImportHeaderProps> = ({
  onClickAddNew,
  onClickRetry,
  onClickFinish,
  onShowSchema,
  onImportData,
  importState,
  onViewImportedLibrary,
  schemaLoading,
  islibaryScope,
  labels: {
    addNewButtonLabel = "Add New",
    retryButtonLabel = "Retry Import",
    finishButtonLabel = "Import Data",
  },
}) => {
  return (
    <div className={containerClassName}>
      <Button
        loading={schemaLoading || false}
        icon={<PartitionOutlined />}
        onClick={onShowSchema}
        size="large"
        type="default"
      >
        Show Schema
      </Button>

      {islibaryScope && onViewImportedLibrary && onImportData && (
        <Button
          size="large"
          type="primary"
          onClick={
            importState.name === "view-libary-imported" ? onImportData : onViewImportedLibrary
          }
        >
          {importState.name === "view-libary-imported" ? "Import Data" : " View Imported Data"}
        </Button>
      )}
      {onClickAddNew && (
        <Button icon={<PlusOutlined />} size="large" type="primary" onClick={onClickAddNew}>
          {addNewButtonLabel}
        </Button>
      )}
      {onClickRetry && (
        <Button size="large" type="primary" onClick={onClickRetry}>
          {retryButtonLabel}
        </Button>
      )}
      {onClickFinish && (
        <Button size="large" type="primary" onClick={onClickFinish}>
          {finishButtonLabel}
        </Button>
      )}
    </div>
  );
};
